

import { Box, IconButton, ThemeProvider, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { MdPrint } from 'react-icons/md';
import brokerGroupApi from '../../../api/brokerGroupApi';
import customtheme from '../../../themes';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';
// import PrintflightReportManifest from './PrintFlightReportManifest';

const FlightManifest = ({ flightId }) => {
  const customization = useSelector((state) => state.customization);   

const rowStyle = {
    display: 'flex', justifyContent: 'flex-end', pb: 1, pt: 1, borderBottom: 'solid 1px rgb(28 117 101 / 41%)'
  };
    const [dataManifest, setDataManifest] = useState(null);

     const contentToPrint = useRef(null);
        const handlePrint = useReactToPrint({
            documentTitle: "چاپ اطلاعات مانیفست پرواز",
            onBeforePrint: () => { },
            onAfterPrint: () => { },
            removeAfterPrint: true,
        });
    
    const GetFlightManifest = () => {
        brokerGroupApi.GetFlightReportManifestById(flightId)
            .then((res) => {
                let Sum_passengersAbove12 = 0;
        let Sum_passengers7To12 = 0;
        let Sum_passengers2To7 = 0;
        let Sum_passengersUnder2 = 0;
        let Sum_numberOfManager = 0;
        let Sum_numberOfcleric = 0;
        let Sum_numberOfDeputy = 0;
        let Sum_numberOfMoeen = 0;
        let Sum_numberOfHeadQuarters = 0;
        let Sum_numberOfShia = 0;
        let Sum_numberOfSunnis = 0;
        let Sum_totalPassengers = 0;

        res.data.data?.groups?.map(row => {
            Sum_passengersAbove12 = Sum_passengersAbove12 + row.passengersAbove12;
            Sum_passengers7To12 = Sum_passengers7To12 + row.passengers7To12;
            Sum_passengers2To7 = Sum_passengers2To7 + row.passengers2To7;
            Sum_passengersUnder2 = Sum_passengersUnder2 + row.passengersUnder2;
            Sum_numberOfManager = Sum_numberOfManager + row.numberOfManager;
            Sum_numberOfcleric = Sum_numberOfcleric + row.numberOfcleric;
            Sum_numberOfDeputy = Sum_numberOfDeputy + row.numberOfDeputy;
            Sum_numberOfMoeen = Sum_numberOfMoeen + row.numberOfMoeen;
            Sum_numberOfHeadQuarters = Sum_numberOfHeadQuarters + row.numberOfHeadQuarters;
            Sum_numberOfShia = Sum_numberOfShia + row.numberOfShia;
            Sum_numberOfSunnis = Sum_numberOfSunnis + row.numberOfSunnis;
            Sum_totalPassengers = Sum_totalPassengers + row.totalPassengers;
        }
        );

        const TotalRow = {
            "Sum_passengersAbove12": Sum_passengersAbove12,
            "Sum_passengers7To12": Sum_passengers7To12,
            "Sum_passengers2To7": Sum_passengers2To7,
            "Sum_passengersUnder2": Sum_passengersUnder2,
            "Sum_numberOfManager": Sum_numberOfManager,
            "Sum_numberOfcleric": Sum_numberOfcleric,
            "Sum_numberOfDeputy": Sum_numberOfDeputy,
            "Sum_numberOfMoeen": Sum_numberOfMoeen,
            "Sum_numberOfHeadQuarters": Sum_numberOfHeadQuarters,
            "Sum_numberOfShia": Sum_numberOfShia,
            "Sum_numberOfSunnis": Sum_numberOfSunnis,
            "Sum_totalPassengers": Sum_totalPassengers
        }
        setDataManifest({
            "flightManifest": res.data.data,
            "totalRow": TotalRow
        });
            }
            )
            .catch((error) => console.log(error));
    }
   
    useEffect(() => {
        
        GetFlightManifest();
    }, [])




    return (
        <>
         <ThemeProvider theme={customtheme(customization)}>
              <div dir="rtl" >
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
            >
                 <Tooltip title="چاپ گزارش پرواز" placement="top">
                                    <IconButton style={{ margin: '2px', borderRadius: 0 }} onClick={() => {
                                        handlePrint(null, () => contentToPrint.current);
                                    }}>
                                        <MdPrint color='#4a148c' />
                                    </IconButton>
                                </Tooltip>
             

            </Box>

            <div  ref={contentToPrint} style={{ border: 'solid 1px #000' }}>
                <div  dir='rtl' style={{ padding: '10px', textAlign: 'center' }}>
                    <Box sx={{ flex: '1 1 auto', mt: 2, mb: 2 }}>
                        <Typography variant='h5' align='center'>بسمه تعالی</Typography>
                    </Box>
                    <Box sx={{ flex: '1 1 0px', mt: 2, mr: 2 }}>
                        <Typography  sx={{ display: 'flex', justifyContent: 'flex-end', pb: 1, pt: 1, border: 0 }} align='center'>
                            <Box sx={{ flex: '1 1 0px', textAlign: 'right' }}>ایستگاه پرواز :</Box><Box sx={{ flex: '1 1 0px', textAlign: 'right' }}>{dataManifest?.flightManifest?.originFlighStationName}</Box>
                            <Box sx={{ flex: '1 1 0px', textAlign: 'right' }}>شماره پرواز :</Box><Box sx={{ flex: '1 1 0px', textAlign: 'right' }}>{dataManifest?.flightManifest?.flightNo}</Box>
                            <Box sx={{ flex: '1 1 0px', textAlign: 'right'}}> شرکت هوایی  :</Box><Box sx={{ flex: '1 1 0px', textAlign: 'right' }}>{dataManifest?.flightManifest?.airlineTypeTitle}</Box>
                            <Box sx={{ flex: '1 1 0px', textAlign: 'right' }}> ظرفیت پرواز : </Box><Box sx={{ flex: '1 1 0px' , textAlign: 'right'}}>{dataManifest?.flightManifest?.flightCapacity}</Box>
                        </Typography>
       
                        <Typography sx={{ display: 'flex', justifyContent: 'flex-end', pb: 1, pt: 1, border: 0 }} align='center'>
                            <Box sx={{ flex: '1 1 0px', textAlign: 'right' }}>تاریخ پرواز شمسی:</Box><Box sx={{ flex: '1 1 0px', textAlign: 'right' }}>{dataManifest?.flightManifest?.flightDatePersian}</Box>
                            <Box sx={{ flex: '1 1 0px', textAlign: 'right' }}>تاریخ پرواز میلادی:</Box><Box sx={{ flex: '1 1 0px', textAlign: 'right' }}>{dataManifest?.flightManifest?.flightDate?.substring(0, 10)}</Box>
                            <Box sx={{ flex: '1 1 0px', textAlign: 'right' }}> ساعت پرواز : </Box><Box sx={{ flex: '1 1 0px', textAlign: 'right' }}>{dataManifest?.flightManifest?.flightTime?.substring(0, 5)}</Box>
                            <Box sx={{ flex: '1 1 0px', textAlign: 'right' }}>مقصد : </Box><Box sx={{ flex: '1 1 0px', textAlign: 'right'}}>{dataManifest?.flightManifest?.destinationFlighStationName}</Box>

                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>

                        <Box sx={{ flex: '1 1 auto', mt: 2, mb: 2 }}>
                            <Typography variant='h5' align='center'>لیست کاروان ها</Typography>
                        </Box>

                    </Box>
                    <table border={1} cellSpacing={0} cellPadding={10} align='center' style={{ fontSize: '14px',  fontFamily:'Vazir-Medium' }}>
                        <thead style={{ background: '#eee',  fontFamily:'Vazir-Medium'}}>
                            <tr>
                                <th>شماره کاروان</th>
                               <th>شماره گروه</th>
                                <th>نام مدیر </th>
                                <th>بالای 12</th>
                                <th>7 تا 12</th>
                                <th>2 تا 7</th>
                                <th>زیر 2</th>
                                <th>مدیر</th>
                                <th>معاون</th>
                                <th>روحانی</th>
                                <th>معین</th>
                                <th>ستادی</th>
                                <th>شیعه</th>
                                <th>سنی</th>
                                <th>جمع</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dataManifest?.flightManifest?.groups?.map(row => (
                                    <tr >
                                        <td>{row.brokerCode}</td>
                                         <td>{row.groupNo}</td>
                                        <td>{row.brokerName}</td>
                                        <td>{row.passengersAbove12}</td>
                                        <td>{row.passengers7To12}</td>
                                        <td>{row.passengers2To7}</td>
                                        <td>{row.passengersUnder2}</td>
                                        <td>{row.numberOfManager}</td>
                                        <td>{row.numberOfcleric}</td>
                                        <td>{row.numberOfDeputy}</td>
                                        <td>{row.numberOfMoeen}</td>
                                        <td>{row.numberOfHeadQuarters}</td>
                                        <td>{row.numberOfShia}</td>
                                        <td>{row.numberOfSunnis}</td>
                                        <td>{row.totalPassengers}</td>
                                    </tr>
                                ))
                            }
                            {
                                <tr key={dataManifest?.flightManifest?.flightId}>
                                    <td></td>
                                     <td></td>
                                    <td>{'مجموع'}</td>
                                    <td>{dataManifest?.totalRow?.Sum_passengersAbove12}</td>
                                        <td>{dataManifest?.totalRow?.Sum_passengers7To12}</td>
                                        <td>{dataManifest?.totalRow?.Sum_passengers2To7}</td>
                                        <td>{dataManifest?.totalRow?.Sum_passengersUnder2}</td>
                                        <td>{dataManifest?.totalRow?.Sum_numberOfManager}</td>
                                        <td>{dataManifest?.totalRow?.Sum_numberOfcleric}</td>
                                        <td>{dataManifest?.totalRow?.Sum_numberOfDeputy}</td>
                                        <td>{dataManifest?.totalRow?.Sum_numberOfMoeen}</td>
                                        <td>{dataManifest?.totalRow?.Sum_numberOfHeadQuarters}</td>
                                        <td>{dataManifest?.totalRow?.Sum_numberOfShia}</td>
                                        <td>{dataManifest?.totalRow?.Sum_numberOfSunnis}</td>
                                        <td>{dataManifest?.totalRow?.Sum_totalPassengers}</td>
                                    
                                </tr>
                            }

                        </tbody>
                    </table>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>

                        <Box sx={{ flex: '1 1 auto', mt: 2, mb: 2 }}>
                            <Typography variant='h5' align='center'>لیست مسافرین آزاد پرواز</Typography>
                        </Box>

                    </Box>
                    <table border={1} cellSpacing={0} cellPadding={10} align='center' style={{ fontSize: '14px',  fontFamily:'Vazir-Medium' }}>
                        <thead style={{ background: '#eee' }}>
                            <tr>
                                <th> ش کاروان </th>
                                <th>نام مدیر</th>
                                <th>نام</th>
                                <th>نام خانوادگی</th>
                                <th>شماره گذرنامه</th>
                                <th>نوع زائر</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dataManifest?.flightManifest?.travelersWithoutGroup?.map(row => (
                                    <tr >
                                        <td>{row.brokerCode }</td>
                                        <td>{row.managerName}</td>
                                        <td>{row.name}</td>
                                        <td>{row.family}</td>
                                        <td>{row.passNO}</td>
                                        <td>{row.passengerTypeTitle}</td>

                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>
                     <Box sx={{ display: 'flex', alignItems: 'center' }}>

                        <Box sx={{ flex: '1 1 auto', mt: 2, mb: 2 }}>
                            <Typography variant='h5' align='center'>لیست مسافرین میهمان پرواز</Typography>
                        </Box>

                    </Box>
                    <table border={1} cellSpacing={0} cellPadding={10} align='center' style={{ fontSize: '14px',  fontFamily:'Vazir-Medium' }}>
                        <thead style={{ background: '#eee' }}>
                            <tr>
                                <th> کد ملی  </th>
                                <th>نام</th>
                                <th>نام خانوادگی</th>
                                <th>شماره گذرنامه</th>
                                <th>نوع میهمان</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dataManifest?.flightManifest?.flightGuests?.map(row => (
                                    <tr >
                                        <td>{row.ssn}</td>
                                        <td>{row.name}</td>
                                        <td>{row.family}</td>
                                        <td>{row.passNO}</td>
                                        <td>{row.guestTypeTitle}</td>

                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>

                        <Box sx={{ flex: '1 1 auto', mt: 2, mb: 2 }}>
                            <Typography variant='h5' align='center'>آمار نهایی پرواز</Typography>
                        </Box>

                    </Box>
                    <table border={1} cellSpacing={0} cellPadding={10} align='center' style={{ fontSize: '14px',  fontFamily:'Vazir-Medium' }}>
                        <thead style={{ background: '#eee' }}>
                            <tr>
                                <th> نوع </th>
                                <th>بالای 12</th>
                                <th>7 تا 12</th>
                                <th>2 تا 7</th>
                                <th>زیر 2</th>
                                <th>میهمان</th>
                                <th>جمع</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dataManifest?.flightManifest?.finalFlightStatistics?.finalFlightStatisticsDetaisls?.map(row => (
                                    <tr >
                                        <td>{row.name}</td>
                                        <td>{row.passengersAbove12}</td>
                                        <td>{row.passengers7To12}</td>
                                        <td>{row.passengers2To7}</td>
                                        <td>{row.passengersUnder2}</td>
                                        <td>{row.totalGUestFlightPassengers}</td>
                                        <td>{row.totalPassengers}</td>

                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>
                    <Box sx={{ flex: '1 1 100px', textAlign: 'center', mt: 2 }}>
                        <Typography variant='h5' align='center'>
                            {'پرواز فوق در تاریخ ' + dataManifest?.flightManifest?.flightDateRealPersian + ' و در ساعت ' + dataManifest?.flightManifest?.realFlightTime + ' ' + (dataManifest?.flightManifest?.delayText ? (' و با تاخیر ' + dataManifest?.flightManifest?.delayText + (dataManifest?.flightManifest?.offScheduleReasonTitle ? '   به علت  ' + dataManifest?.flightManifest?.offScheduleReasonTitle : '')) : ' و بدون تاخیر ') + ' انجام شد '}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>

                        <Box sx={{ flex: '1 1 auto', mt: 2, mb: 2 }}>
                            <Typography variant='h5' align='center'>لیست مسافرین غایب پرواز</Typography>
                        </Box>

                    </Box>
                    <table border={1} cellSpacing={0} cellPadding={10} align='center' style={{ fontSize: '14px',  fontFamily:'Vazir-Medium' }}>
                        <thead style={{ background: '#eee' }}>
                            <tr>
                                <th> ش کاروان </th>
                                <th>نام مدیر</th>
                                <th>نام</th>
                                <th>نام خانوادگی</th>
                                <th>شماره گذرنامه</th>
                                <th>نوع زائر</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dataManifest?.flightManifest?.absentPassengers?.map(row => (
                                    <tr >
                                        <td>{row.brokerCode }</td>
                                        <td>{row.managerName}</td>
                                        <td>{row.name}</td>
                                        <td>{row.lastName}</td>
                                        <td>{row.passNo}</td>
                                        <td>{row.passengerTypeTitle}</td>

                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>
                     
                </div>
            </div>
</Box>
</div>
</ThemeProvider>
        </>

    )
}

export default FlightManifest